import * as moment from 'moment';
import 'moment-timezone';
import * as numeral from 'numeral';
import { AppSettings } from './appsettings';

export class DateValueConverter {
	toView(value: string, format: string = null) {
		if (!format) {
			format = 'D.M.YYYY';
		}

		return moment(value).tz(AppSettings.timezone).format(format);
	}

	fromView(value: string, format: string = null){

		if (!format) {
			format = 'D.M.YYYY';
		}

		return moment(value, format);
	}
}

export class TimestampValueConverter {
	toView(value: string) {
		if (!value) {
			return '';
		}

		return moment(value).tz(AppSettings.timezone).format('D.M.YYYY H:mm');
	}
}

export class CurrencyValueConverter {
	toView(value, params) {
		if (value === null || value === undefined) {
			return '';
		}
		return numeral(value).format('0,0.00 $');
	}
}

export class HasItemsValueConverter {
	toView(value: Array<any>) {
		return value && value.length > 0;
	}
}

export class JoinValueConverter {
	toView<T>(items: Array<T>, separator: string = ", ") {

		if (!items) { return ""; }
		return items.join(separator);
	}
}

export class JoinWithHtmlBreakValueConverter {
	toView<T>(items: Array<T>) {

		if (!items) { return ""; }
		return items.join('<br />');
	}
}

export class LimitLengthValueConverter {
	toView(value: string, maxLength: number, endLength: number) {
		maxLength = maxLength || 30;

		if (!value || value.length <= maxLength) {
			return value;
		}

		endLength = endLength !== 0 && endLength == null
			? Math.max(...[Math.ceil(maxLength / 5), 4])
			: endLength;
		const startLength = maxLength - endLength - 3;

		return value.substring(0, startLength) + '...'
			+ (endLength !== 0 ? value.slice(-endLength) : '');
	}
}

export class KeysValueConverter {
	toView(obj) {
		if (obj == null) {
			return [];
		}
		return Object.keys(obj);
	}
}

export class NumberValueConverter {
	toView(value: number, numberOfDecimals = 2) {
		if (value == null) {
			return '-';
		}

		if (numberOfDecimals === 0 && value !== 0 && Math.abs(value) < 1) {
			numberOfDecimals = 1;
		}

		const decimalFormat = numberOfDecimals === 0 ? '' : '.' + Array(numberOfDecimals + 1).join('0');
		return numeral(value).format('0,0' + decimalFormat);
	}

	addThousandsSeparators(x) {
		return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
	}
}

export class LowerCaseValueConverter {
	toView(value: string, caseType: string) {
		return value ? value.toLowerCase() : '';
	}
}

export class HighLightValueConverter {
	toView(value: string, highLightPart: string) {
		if(!value) {
			return '';
		}
		if(!highLightPart || !highLightPart.length) {
			return value;
		}

		const startIndex = value.toLowerCase().indexOf(highLightPart.toLowerCase());
		const endIndex = startIndex + highLightPart.length;
		const originalText = value.substring(startIndex, endIndex);

		return `${value.slice(0, startIndex)}<strong>${originalText}</strong>${value.slice(endIndex, value.length)}`;
	}
}

export class LineBreakValueConverter{
	toView(value: string){
		if (!value) { return ''; }

		return value.replace(/(?:\r\n|\r|\n)/g, '<br />');
	}
}

